// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"logo-container_logoWrapper__WegjL"};